import { render, staticRenderFns } from "./DangerHiddenDetail.vue?vue&type=template&id=5c8b0535&scoped=true"
import script from "./DangerHiddenDetail.vue?vue&type=script&lang=js"
export * from "./DangerHiddenDetail.vue?vue&type=script&lang=js"
import style0 from "./DangerHiddenDetail.vue?vue&type=style&index=0&id=5c8b0535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8b0535",
  null
  
)

export default component.exports